import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "purchaseAgreementExtraction";

export const usePurchaseAgreementExtractionStore = defineStore(storeName, () => {
  const { baseMultipartPost } = useBase(storeName);
  const extraction = ref(null);
  const isExtracting = ref(false);

  const extract = async (file, firstPages, lastPages, callback, errorCallback) => {
    isExtracting.value = true;
    extraction.value = null;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("first_pages", firstPages);
    formData.append("last_pages", lastPages);
    await baseMultipartPost(
      "purchase-agreement-extractions",
      formData,
      (data) => {
        extraction.value = data;
        isExtracting.value = false;
        if (callback) callback(data);
      },
      (errors) => {
        isExtracting.value = false;
        if (errorCallback) errorCallback(errors);
      },
    );
  };

  const reset = () => {
    extraction.value = null;
    isExtracting.value = false;
  };

  return {
    extraction,
    isExtracting,
    extract,
    reset,
  };
});
